import React, { useState, useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';


import config from '../../config'; 

function VehicleRepoList() {

  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState("");
  const [page, setPage] = useState(1);
  const [loadingId, setLoadingId] = useState(null);
  const [uploadingId, setUploadingId] = useState(null);
  const [files, setFiles] = useState({});

  // --- PRELOADER: tracks POST request in-flight state (for modal submissions) ---
  const [postLoading, setPostLoading] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [notes, setNotes] = useState("");
  const [showResendModal, setShowResendModal] = useState(false);
  const [resendAgreement, setResendAgreement] = useState("");
  const [resendNotes, setResendNotes] = useState("");
  const [showReuploadModal, setShowReuploadModal] = useState(false);
  const [reuploadAgreement, setReuploadAgreement] = useState("");
  const [showViewNotesModal, setShowViewNotesModal] = useState(false);
  const [viewNotesContent, setViewNotesContent] = useState("");
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [activityLoading, setActivityLoading] = useState(false);
  const [expandedNotes, setExpandedNotes] = useState({});
  const [expandedRow, setExpandedRow] = useState(null);
  const [showFlowModal, setShowFlowModal] = useState(false);
  const [selectedFlowItem, setSelectedFlowItem] = useState(null);

const handleViewActivities = async (agreementNo) => {

  try {

    setActivityLoading(true);
    setShowActivityModal(true);

    const res = await fetch(
      `${config.API_BASE_URL}getCaseActivityLogs/${agreementNo}`
    );

    const result = await res.json();

    if (result.status) {

      setActivityLogs(result.data || []);

    } else {

      toast.error(result.message || "No activities found");
      setActivityLogs([]);

    }

  } catch {

    toast.error("Failed to load activities");

  } finally {

    setActivityLoading(false);

  }
};
  
const handleStaticFlowModal = async (item) => {

  try {

    setActivityLoading(true);

    const res = await fetch(
      `${config.API_BASE_URL}getCaseActivityLogs/${item.AgreementNo}`
    );

    const result = await res.json();

    if (result.status) {

      setActivityLogs(result.data || []);

    } else {

      setActivityLogs([]);

    }

  } catch {

    setActivityLogs([]);

  } finally {

    setActivityLoading(false);

  }

  setSelectedFlowItem(item);

  setShowFlowModal(true);

};
  
  const navigate = useNavigate();
  const perPage = 10;

 
  const userInfo = useSelector((state) => state.userInfo);
  
  const userId = userInfo?.id;
  const userRole = userInfo?.roleIdWithName?.[0]?.role_name?.toLowerCase().trim();
  const allowedRepoUsers = [
    "super admin",
    "manager",
    "team leader",
    "user",
    "dealer",
    "regional sales manager",
    "regional head",
    "cluster head"
  ];

console.log("ROLE:", userRole);
  const isAdmin = userRole === "super admin";
  
  const isMaker = [
    "user",
    "manager",
    "team leader",
    "regional sales manager",
    "regional head",
    "cluster head",
    "super admin"
  ].includes(userRole);

  const isChecker = [
    "credit operations",
    "super admin"
  ].includes(userRole);

const allowedStatuses = isChecker
  ? [
      "Pending",
      "Pending for Court Order Review"
    ]
  : [
      "Pending",
      "Approved",
      "Rejected",
      "Pending for Court Order Review",
      "Court Order Rejected"
    ];

const visibleData = data.filter(item => {

  const status =
    item.legal_status || item.status;

  // ===== CREDIT OPERATIONS / CHECKER =====
  if (isChecker) {

    return [
      "Pending",
      "Pending for Court Order Review"
    ].includes(status);

  }

  // ===== MAKER / OTHER USERS =====
  return (
    !status ||
    [
      "Pending",
      "Approved",
      "Rejected",
      "Pending for Court Order Review",
      "Court Order Rejected"
    ].includes(status)
  );

});

  const fetchData = () => {
    fetch(`${config.API_BASE_URL}getEligibleLoansForRepo`)
      .then(res => res.json())
      .then(res => {
        if (res.status) {
          setData(res.data);
        } else {
          toast.error("Failed to load data");
        }
      })
      .catch(() => toast.error("API Error"));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSendForApproval = async (agreementNo) => {
    try {
      setLoadingId(agreementNo);

      const res = await fetch(`${config.API_BASE_URL}createLegalAction`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          agreement_no: agreementNo,
          legal_type: "Section 9",
          user_id: userId
        })
      });

      const result = await res.json();

      if (result.status) {
        toast.success("Sent for approval");
        fetchData();
      } else {
        toast.error(result.message);
      }

    } catch {
      toast.error("Error sending request");
    } finally {
      setLoadingId(null);
    }
  };


  const handleAction = async (agreementNo, action) => {
    try {
      const res = await fetch(`${config.API_BASE_URL}approverejectLegalAction`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          agreement_no: agreementNo,
          action,
          checker_id: userId
        })
      });

      const result = await res.json();

      if (result.status) {
        toast.success(`Action ${action} successful`);
        fetchData();
      } else {
        toast.error(result.message);
      }

    } catch {
      toast.error("Error processing action");
    }
  };

  const handleDownloadCourtOrder = (courtOrderFile) => {
  if (!courtOrderFile) {
    toast.error("Court order file not available");
    return;
  }

  const fileUrl = `${config.API_BASE_URL}${courtOrderFile}`;
  window.open(fileUrl, '_blank');
};

const handleUploadCourtOrder = async (agreementNo) => {
  const selectedFile = files[agreementNo];

  if (!selectedFile) {
    toast.error("Please select file");
    return;
  }

  const formData = new FormData();
  formData.append("agreement_no", agreementNo);
  formData.append("file", selectedFile);
  formData.append("user_id", userId);

  // --- PRELOADER: show overlay before POST request ---
  setPostLoading(true);

  try {
    const res = await fetch(`${config.API_BASE_URL}uploadCourtOrder`, {
      method: "POST",
      body: formData
    });

    const result = await res.json();

    if (result.status) {
      toast.success("Court order uploaded");
      setUploadingId(null);

      setFiles(prev => {
        const updated = { ...prev };
        delete updated[agreementNo];
        return updated;
      });

      fetchData();
    } else {
      toast.error(result.message);
    }
  } catch {
    toast.error("Upload failed");
  } finally {
    // --- PRELOADER: hide overlay after POST finishes ---
    setPostLoading(false);
  }
};

const handleCourtOrderAction = (agreementNo, action) => {

  setSelectedAgreement(agreementNo);
  setSelectedAction(action);
  setNotes("");
  setShowNotesModal(true);

};  

const handleReuploadCourtOrder = (agreementNo) => {

  setReuploadAgreement(agreementNo);
  setResendNotes("");
  setShowReuploadModal(true);

};

const repoFlowSteps = [

  "Pending",
  "Approved",
  "Pending for Court Order Review",
  "Court Order Approved",
  "Repo Initiated",
  "Repo Checklist Submitted",
  "Inspection Scheduled",
  "Inventory Created",
  "Yard Placement Pending",
  "Vehicle Yarded",
  "Ready For Listing Approval",
  "Listing Approved",
  "Live For Auction",
  "Auction Completed",
  "Case Closed"

];

const logStepMap = {

  "legal action created": 1,
  "legal action approved": 2,
  "court order uploaded": 3,
  "court order approved": 4,
  "repo process initiated": 5,
  "repo checklist submitted": 6,
  "inspection scheduled": 7,
  "final inventory created": 8,
  "yard placement updated": 9,
  "vehicle yarded": 10,
  "ready for listing approval": 11,
  "listing approved": 12,
  "live for auction": 13,
  "auction completed": 14,
  "case closed": 15

};

let currentStep = 1;

if (activityLogs?.length > 0) {

  const sortedLogs = [...activityLogs].sort(
    (a, b) =>
      new Date(b.created_on) -
      new Date(a.created_on)
  );

  sortedLogs.some((log) => {

    const matchedKey =
      Object.keys(logStepMap).find((key) =>
        log.log_description
          ?.toLowerCase()
          .includes(key.toLowerCase())
      );

    if (matchedKey) {

      currentStep = logStepMap[matchedKey];

      return true;

    }

    return false;

  });

}

const filtered = visibleData.filter(item => {

  const status =
    item.legal_status || item.status || "";

  const matchesSearch =
    (item.AgreementNo || '')
      .toLowerCase()
      .includes(search.toLowerCase()) ||

    (item.contact_name || '')
      .toLowerCase()
      .includes(search.toLowerCase());

  const matchesStatus =
    !statusFilter ||
    status === statusFilter;

  return matchesSearch && matchesStatus;

});

const handleExportExcel = () => {

  const headers = [

    "Sr No",
    "Agreement No",
    "Customer",
    "Phone",
    "DPD",
    "Status",
    "Notes",
    "Created By",
    "Updated By"

  ];

  const rows = filtered.map((item, index) => [

    index + 1,

    item.AgreementNo || "-",

    item.contact_name || "-",

    item.mobile || "-",

    item.DPDDays || "-",

    item.legal_status ||
    item.status ||
    "Eligible",

    item.notes || "-",

    item.created_by_name || "-",

    item.updated_by_name || "-"

  ]);

  const csvContent = [

    headers.join(","),

    ...rows.map(row =>
      row.map(value =>
        `"${String(value).replace(/"/g, '""')}"`
      ).join(",")
    )

  ].join("\n");

  const blob = new Blob(
    [csvContent],
    {
      type: "text/csv;charset=utf-8;"
    }
  );

  const link =
    document.createElement("a");

  const url =
    URL.createObjectURL(blob);

  link.setAttribute("href", url);

  link.setAttribute(
    "download",
    `Legal_Action_List_${Date.now()}.csv`
  );

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

};

const submitCourtOrderAction = async () => {

  if (!notes.trim()) {
    toast.error("Please enter notes");
    return;
  }

  try {

    // --- PRELOADER: show overlay before POST request ---
    setPostLoading(true);

    const res = await fetch(
      `${config.API_BASE_URL}approveRejectCourtOrder`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          agreement_no: selectedAgreement,
          action: selectedAction,
          checker_id: userId,
          notes
        })
      }
    );

    const result = await res.json();

    if (result.status) {

      toast.success(result.message);

      setShowNotesModal(false);
      setNotes("");
      setSelectedAgreement("");
      setSelectedAction("");

      fetchData();

    } else {

      toast.error(result.message);

    }

  } catch {

    toast.error("Something went wrong");

  } finally {

    // --- PRELOADER: hide overlay after POST finishes ---
    setPostLoading(false);

  }
};

const submitReuploadCourtOrder = async () => {

  const selectedFile = files[reuploadAgreement];

  if (!selectedFile) {
    toast.error("Please select file");
    return;
  }

  if (!resendNotes.trim()) {
    toast.error("Please enter notes");
    return;
  }

  const formData = new FormData();

  formData.append("agreement_no", reuploadAgreement);
  formData.append("file", selectedFile);
  formData.append("user_id", userId);
  formData.append("notes", resendNotes);

  try {

    // --- PRELOADER: show overlay before POST request ---
    setPostLoading(true);

    const res = await fetch(
      `${config.API_BASE_URL}uploadCourtOrder`,
      {
        method: "POST",
        body: formData
      }
    );

    const result = await res.json();

    if (result.status) {

      toast.success(result.message);

      setShowReuploadModal(false);
      setReuploadAgreement("");
      setResendNotes("");

      fetchData();

    } else {

      toast.error(result.message);

    }

  } catch {

    toast.error("Upload failed");

  } finally {

    // --- PRELOADER: hide overlay after POST finishes ---
    setPostLoading(false);

  }
};

  // 📄 PAGINATION
  const start = (page - 1) * perPage;
  const paginated = filtered.slice(start, start + perPage);
  const totalPages = Math.ceil(filtered.length / perPage);

  return (
    <Container>

      {/* --- PRELOADER OVERLAY: shown during POST request --- */}
      {postLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(3px)'
          }}
        >
          <div
            style={{
              width: '56px',
              height: '56px',
              border: '5px solid #e0e0e0',
              borderTop: '5px solid #1976d2',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }}
          />
          <p style={{ marginTop: '18px', fontWeight: 600, color: '#1976d2', fontSize: '15px' }}>
            Processing, please wait...
          </p>
          {[1,2,3].map(i => (
            <div
              key={i}
              style={{
                width: '320px',
                height: '14px',
                borderRadius: '6px',
                marginTop: '10px',
                background: 'linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)',
                backgroundSize: '400% 100%',
                animation: 'shimmer 1.4s infinite'
              }}
            />
          ))}
          <style>{`
            @keyframes spin { to { transform: rotate(360deg); } }
            @keyframes shimmer { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
          `}</style>
        </div>
      )}
      {/* --- END PRELOADER OVERLAY --- */}


      <div className="d-flex justify-content-between align-items-center mb-3">
        <Typography variant="h4">Eligible Loans for Legal Action</Typography>
      </div>

    <div className="d-flex justify-content-end mb-2">

      <button
        className="btn btn-success"
        onClick={handleExportExcel}
        style={{
          fontSize: "12px",
          padding: "6px 14px"
        }}
      >
        ⬇ Export Excel
      </button>

    </div>

      {/* SEARCH */}
      <div className="row mb-3">

  <div className="col-md-3">

    <select
      className="form-select"
      value={statusFilter}
      onChange={(e) =>
        setStatusFilter(e.target.value)
      }
    >

      <option value="">
        All Status
      </option>

      {allowedStatuses.map(status => (

        <option
          key={status}
          value={status}
        >
          {status}
        </option>

      ))}

    </select>

  </div>

  <div className="col-md-4 ms-auto">
          <input
            type="text"
            className="form-control"
            placeholder="Search Agreement / Customer..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* TABLE */}
      <div className="table-wrap">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th style={{width:'40px'}}/>
              <th>#</th>
              <th>Agreement No</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>DPD</th>
              <th>Status</th>
              <th width="220">Action</th>
              <th width="120">All Activities</th>
            </tr>
          </thead>

          <tbody>
            {paginated.map((item, index) => {
              const status = item.legal_status || item.status || "Eligible";
              const isExpanded = expandedRow === item.AgreementNo;
              return (
                <tr key={item.AgreementNo} style={{ cursor: 'pointer' }} onClick={() => setExpandedRow(isExpanded ? null : item.AgreementNo)}>
                  <td style={{textAlign:'center', verticalAlign:'middle'}}>
                    <span style={{
                      display:'inline-block',
                      transition:'transform 0.25s',
                      transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                      fontSize:'16px',
                      color:'#555'
                    }}>&#8250;</span>
                  </td>
                   <td>{start + index + 1}</td>
                  <td>
                      <Link
                          to={`/dashboard/allcloud-loans-report/${btoa(String(item.id))}/${btoa(String(item.AgreementNo))}`}
                          style={{ color: "#0d6efd", textDecoration: "underline" }}
                          onClick={e => e.stopPropagation()}
                        >
                          {item.AgreementNo}
                        </Link>
                    </td>
                  <td>{item.contact_name || '-'}</td>
                  <td>{item.mobile || '-'}</td>
                  <td>{item.DPDDays}</td>

                  {/* STATUS */}
                <td>

                    {!status && (
                      <span className="badge bg-warning text-dark">
                        Eligible
                      </span>
                    )}

                    {status === "Pending" && (
                      <span className="badge bg-secondary">
                        Waiting
                      </span>
                    )}

                    {status === "Approved" && (
                      <span className="badge bg-success">
                        Approved
                      </span>
                    )}

                    {status === "Rejected" && (
                      <span className="badge bg-danger">
                        Rejected
                      </span>
                    )}

                    {status === "Pending for Court Order Review" && (
                      <span className="badge bg-warning text-dark">
                        Court Order Uploaded
                      </span>
                    )}

                    {status === "Court Order Approved" && (
                      <span className="badge bg-success">
                        Court Order Approved
                      </span>
                    )}

                    {status === "Court Order Rejected" && (
                      <span className="badge bg-danger">
                        Court Order Rejected
                      </span>
                    )}

                    {status === "Repo Initiated" && (
                      <span className="badge bg-info text-dark">
                        Repo Initiated
                      </span>
                    )}

                    {status === "Repo Checklist Submitted" && (
                       <span className="badge bg-primary">
                         Repo Checklist Submitted
                       </span>
                     )}

                </td>

                 <td onClick={e => e.stopPropagation()}>
                {/* REJECTED */}
                {status === "Rejected" && (
                  <div>
                    {isExpanded && (
                      <span className="text-danger d-block">
                        Rejected by {item.updated_by_name || "User"}
                      </span>
                    )}

                    {(isMaker || isAdmin) && (
                      <button
                        className="btn btn-sm btn-warning mt-1"
                        style={{
                          padding: "4px 10px",
                          fontSize: "9px",
                          textTransform: "capitalize"
                        }}
                        onClick={() => handleSendForApproval(item.AgreementNo)}
                      >
                        Send for Approval
                      </button>
                    )}
                  </div>
                )}

                {/* NEW CASE (no record yet) */}
                {(isMaker || isAdmin) && !item.legal_status && (
                  <button
                    className="btn btn-sm btn-warning"
                    style={{
                      padding: "4px 10px",
                      fontSize: "9px",
                      textTransform: "capitalize"
                    }}
                    onClick={() => handleSendForApproval(item.AgreementNo)}
                  >
                    Send for Approval
                  </button>
                )}

                {status === "Pending" && (
                  <>
                    {isChecker ? (
                      <>
                        {isExpanded && (
                          <small className="text-primary d-block mb-1">
                            Sent for Approval by{" "}
                            {
                              item.updated_by_name &&
                              item.notes
                                ? item.updated_by_name
                                : item.created_by_name || "User"
                            }
                          </small>
                        )}

                        <button
                          className="btn btn-sm btn-success me-2"
                           style={{
                            height: "23px",
                            borderRadius: "5px",
                            padding: "5px 7px",
                            fontSize: "8.2px",
                            minWidth: "90px",
                            fontWeight: "normal"
                          }}
                          onClick={() => handleAction(item.AgreementNo, "approve")}
                        >
                          ✓ Accept
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          style={{
                            height: "23px",
                            borderRadius: "5px",
                            padding: "5px 7px",
                            fontSize: "8.2px",
                            minWidth: "90px",
                            fontWeight: "normal"
                          }}
                          onClick={() => handleAction(item.AgreementNo, "reject")}
                        >
                          ✕ Reject
                        </button>
                      </>
                    ) : (
                      isExpanded && (
                        <span className="text-primary">
                          Sent for Approval by {item.created_by_name || "User"}
                        </span>
                      )
                    )}
                  </>
                )}


                {/* APPROVED — Maker uploads court order file */}
                {status === "Approved" && (isMaker || isAdmin) && (
                  <div className="mt-1">
                    {uploadingId === item.AgreementNo ? (
                      <div>
                        <input
                          type="file"
                          className="form-control form-control-sm mb-1"
                          accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                          onChange={(e) =>
                            setFiles(prev => ({
                              ...prev,
                              [item.AgreementNo]: e.target.files[0]
                            }))
                          }
                        />
                        <button
                          className="btn btn-sm btn-success me-1"
                          onClick={() => handleUploadCourtOrder(item.AgreementNo)}
                        >
                          Upload
                        </button>
                        <button
                          className="btn btn-sm btn-secondary"
                          onClick={() => setUploadingId(null)}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <button
                        className="btn btn-sm btn-primary"
                        style={{
                          padding: "4px 10px",
                          fontSize: "9px",
                          textTransform: "capitalize"
                        }}
                        onClick={() => setUploadingId(item.AgreementNo)}
                      >
                        Upload Court Order
                      </button>
                    )}
                  </div>
                )}

                {status === "Pending for Court Order Review" && isChecker && (
                  <div className="d-flex flex-column gap-1">
                    {isExpanded && (
                      <>
                        <small className="text-primary d-block mb-1">
                          Sent for Court Order Approval by{" "}
                          {
                            item.updated_by_name &&
                            item.notes
                              ? item.updated_by_name
                              : item.created_by_name || "User"
                          }
                        </small>

                        <button
                          type="button"
                          onClick={() =>
                            handleDownloadCourtOrder(item.court_order_file)
                          }
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: "0",
                            width: "fit-content",
                            color: "#0dcaf0",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: "600",
                            textDecoration: "underline"
                          }}
                        >
                          ⬇ Download Court Order
                        </button>

                        {item.notes && (
                          <button
                            type="button"
                            title="View re-upload notes from maker"
                            onClick={() => {
                              setViewNotesContent(item.notes);
                              setShowViewNotesModal(true);
                            }}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: "0",
                              width: "fit-content",
                              color: "#6c757d",
                              cursor: "pointer",
                              fontSize: "12px",
                              fontWeight: "500",
                              textDecoration: "underline"
                            }}
                          >
                            👁 View Notes
                          </button>
                        )}
                      </>
                    )}

                    <button
                      className="btn btn-success btn-sm"
                      style={{
                        padding: "4px 10px",
                        fontSize: "9px",
                        textTransform: "capitalize"
                      }}
                      onClick={() =>
                        handleCourtOrderAction(item.AgreementNo, "approve")
                      }
                    >
                      ✓ Approve Court Order
                    </button>

                    <button
                      className="btn btn-danger btn-sm"
                       style={{
                          padding: "4px 10px",
                          fontSize: "9px",
                          textTransform: "capitalize"
                        }}
                      onClick={() =>
                        handleCourtOrderAction(item.AgreementNo, "reject")
                      }
                    >
                      ✕ Reject Court Order
                    </button>

                  </div>
                )}

                {status === "Pending for Court Order Review" && !isChecker && (
                  isExpanded && (
                    <span className="text-warning d-block mt-1">
                      Waiting for Court Order Approval
                    </span>
                  )
                )}

                {status === "Court Order Approved" && !isChecker && (
                  <div className="mt-1">
                    {isExpanded && (
                      <>
                        <span className="text-success d-block">
                          Court Order Approved by{" "}
                          {item.updated_by_name || "Credit Operations"}
                        </span>

                        <div
                          style={{
                            marginTop: "8px",
                            maxWidth: "260px"
                          }}
                        >
                          <div
                            style={{
                              fontSize: "13px",
                              color: "#6c757d",
                              lineHeight: "1.5",
                              wordBreak: "break-word",
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: expandedNotes[item.AgreementNo] ? "none" : 2,
                              WebkitBoxOrient: "vertical"
                            }}
                          >
                            <strong>Notes:</strong>{" "}
                            {item.notes}
                          </div>

                          {item.notes && item.notes.length > 15 && (
                            <button
                              type="button"
                              onClick={() =>
                                setExpandedNotes(prev => ({
                                  ...prev,
                                  [item.AgreementNo]: !prev[item.AgreementNo]
                                }))
                              }
                              style={{
                                color: "#0d6efd",
                                fontSize: "12px",
                                fontWeight: "600",
                                cursor: "pointer",
                                marginTop: "4px",
                                display: "inline-block",
                                background: "transparent",
                                border: "none",
                                padding: 0
                              }}
                            >
                              {expandedNotes[item.AgreementNo] ? "Read Less" : "Read More"}
                            </button>
                          )}
                        </div>
                      </>
                    )}

                    <button
                      className="btn btn-sm btn-primary mt-2"
                          onClick={() => {

                      if (
                        !allowedRepoUsers.includes(
                          userRole?.toLowerCase()
                        )
                      ) {

                        toast.error("Access Denied");

                        return;
                      }

                      navigate(
                        `/dashboard/create-vehicle-repo/${btoa(String(item.AgreementNo))}`
                      );

                    }}
                    style={{
                        padding: "4px 10px",
                        fontSize: "9px",
                        textTransform: "capitalize"
                      }}
                    >
                      START REPO PROCESS
                    </button>

                  </div>
                  )}

                  {status === "Repo Initiated" && !isChecker && (
                  <div className="mt-1">
                    {isExpanded && (
                      <>
                        <span className="text-info d-block">
                          Repo process initiated successfully
                        </span>
                        <small className="text-success d-block mt-1">
                          Submitted By: {item.updated_by_name || "User"}
                        </small>

                        <div
                          style={{
                            marginTop: "6px",
                            maxWidth: "260px"
                          }}
                        >
                          <div
                            style={{
                              fontSize: "13px",
                              color: "#6c757d",
                              lineHeight: "1.5",
                              wordBreak: "break-word",
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: expandedNotes[item.AgreementNo] ? "none" : 2,
                              WebkitBoxOrient: "vertical"
                            }}
                          >
                            <strong>Notes:</strong>{" "}
                            {item.notes}
                          </div>

                          {item.notes && item.notes.length > 15 && (
                            <button
                              type="button"
                              onClick={() =>
                                setExpandedNotes(prev => ({
                                  ...prev,
                                  [`${item.AgreementNo}_repo`]: !prev[`${item.AgreementNo}_repo`]
                                }))
                              }
                              style={{
                                color: "#0d6efd",
                                fontSize: "12px",
                                fontWeight: "600",
                                cursor: "pointer",
                                marginTop: "4px",
                                display: "inline-block",
                                background: "transparent",
                                border: "none",
                                padding: 0
                              }}
                            >
                              {expandedNotes[`${item.AgreementNo}_repo`] ? "Read Less" : "Read More"}
                            </button>
                          )}
                        </div>
                      </>
                    )}

                      <button
                        className="btn btn-sm btn-dark mt-2"
                        onClick={() => {

                            if (
                              !allowedRepoUsers.includes(
                                userRole?.toLowerCase()
                              )
                            ) {

                              toast.error("Access Denied");

                              return;
                            }

                            navigate(
                              `/dashboard/repo-conditions-checklist/${item.repo_id}`
                            );

                          }}
                          style={{
                            padding: "4px 10px",
                            fontSize: "9px",
                            textTransform: "capitalize"
                          }}
                      >
                        OPEN REPO CHECKLIST
                      </button>

                    </div>
                  )}
                  {status === "Repo Checklist Submitted" && !isChecker && (
                  <div className="mt-1">
                    {isExpanded && (
                      <>
                        <span className="text-success d-block">
                          Repo checklist submitted successfully
                        </span>

                        <small className="text-success d-block mt-1">
                          Submitted By: {item.updated_by_name || "User"}
                        </small>

                        <small className="text-muted d-block mt-1">
                          Inspection / Yard placement pending
                        </small>
                      </>
                    )}

                    <div className="d-flex gap-2 flex-wrap mt-2">

                        <button
                          className="btn btn-sm btn-dark"
                          onClick={() => {

                            navigate(
                              `/dashboard/view-repo-checklist/${item.repo_id}`
                            );

                          }}
                          style={{
                            padding: "4px 10px",
                            fontSize: "9px",
                            textTransform: "capitalize"
                          }}
                        >
                          View Checklist
                        </button>

                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => {

                            if (
                              !allowedRepoUsers.includes(
                                userRole?.toLowerCase()
                              )
                            ) {

                              toast.error("Access Denied");
                              return;

                            }

                            navigate(
                              `/dashboard/schedule-inspection/${item.repo_id}`
                            );

                          }}
                          style={{
                            padding: "4px 10px",
                            fontSize: "9px",
                            textTransform: "capitalize"
                          }}
                        >
                          Open schedule Inspection
                        </button>

                      </div>

                    </div>
                  )}

                {status === "Court Order Rejected" && !isChecker && (
                  <div className="mt-1">
                    {isExpanded && (
                      <>
                        <span className="text-danger d-block">
                          Court Order Rejected by{" "}
                          {item.updated_by_name || "Credit Operations"}
                        </span>

                        <div
                          style={{
                            marginTop: "6px",
                            maxWidth: "260px"
                          }}
                        >
                          <div
                            style={{
                              fontSize: "13px",
                              color: "#6c757d",
                              lineHeight: "1.5",
                              wordBreak: "break-word",
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitLineClamp: expandedNotes[item.AgreementNo] ? "none" : 2,
                              WebkitBoxOrient: "vertical"
                            }}
                          >
                            <strong>Notes:</strong>{" "}
                            {item.notes}
                          </div>

                          {item.notes && item.notes.length > 15 && (
                            <button
                              type="button"
                              onClick={() =>
                                setExpandedNotes(prev => ({
                                  ...prev,
                                  [item.AgreementNo]: !prev[item.AgreementNo]
                                }))
                              }
                              style={{
                                color: "#0d6efd",
                                fontSize: "12px",
                                fontWeight: "600",
                                cursor: "pointer",
                                marginTop: "4px",
                                display: "inline-block",
                                background: "transparent",
                                border: "none",
                                padding: 0
                              }}
                            >
                              {expandedNotes[item.AgreementNo] ? "Read Less" : "Read More"}
                            </button>
                          )}
                        </div>
                      </>
                    )}

                      {uploadingId === item.AgreementNo ? (
                        <div className="mt-2">

                          <input
                            type="file"
                            className="form-control form-control-sm mb-1"
                            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                            onChange={(e) =>
                              setFiles(prev => ({
                                ...prev,
                                [item.AgreementNo]: e.target.files[0]
                              }))
                            }
                          />

                          <button
                            className="btn btn-sm btn-success me-1"
                            onClick={() => handleUploadCourtOrder(item.AgreementNo)}
                          >
                            Upload
                          </button>

                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => setUploadingId(null)}
                          >
                            Cancel
                          </button>

                        </div>
                      ) : (
                        <button
                          className="btn btn-sm btn-warning mt-2"
                          style={{
                            padding: "4px 10px",
                            fontSize: "9px",
                            textTransform: "capitalize"
                          }}
                          onClick={() => handleReuploadCourtOrder(item.AgreementNo)}
                        >
                          Re-Upload Court Order
                        </button>
                      )}

                    </div>
                  )}


                </td>
                <td onClick={e => e.stopPropagation()}>

              <button
                className="btn btn-sm btn-dark"
                style={{
                  padding: "4px 10px",
                  fontSize: "9px",
                  textTransform: "capitalize"
                }}
                onClick={() =>
                  handleViewActivities(item.AgreementNo)
                }
              >
                👁 View
              </button>

              <button
                className="btn btn-sm btn-info mt-1"
                style={{
                  padding: "4px 10px",
                  fontSize: "9px",
                  textTransform: "capitalize"
                }}
                onClick={() =>
                  handleStaticFlowModal(item)
                }
              >
                View Progress
              </button>

            </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <nav>
        <ul className="pagination justify-content-end">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
            <li className="page-item" key={p}>
              <button
                className="page-link"
                onClick={() => setPage(p)}
                disabled={page === p}
              >
                {p}
              </button>
            </li>
          ))}
        </ul>
      </nav>

{showReuploadModal && (
  <div
    className="modal show fade d-flex align-items-center justify-content-center"
    tabIndex="-1"
    style={{
      position: "fixed",
      inset: 0,
      width: "100vw",
      height: "100vh",

      background: "rgba(15, 23, 42, 0.60)",
      backdropFilter: "blur(3px)",

      zIndex: 999999,

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      padding: "20px"
    }}
  >
    <div
      className="modal-dialog"
      style={{
        width: "100%",
        maxWidth: "620px",
        margin: 0
      }}
    >
      <div
        className="modal-content"
        style={{
          borderRadius: "18px",
          border: "none",
          overflow: "hidden",
          boxShadow: "0 10px 35px rgba(0,0,0,0.18)",
          marginLeft: '70px'
        }}
      >

        {/* HEADER */}
        <div
          className="modal-header"
          style={{
            padding: "22px 26px",
            borderBottom: "1px solid #ececec"
          }}
        >
          <div>
            <h4
              className="modal-title mb-1"
              style={{
                fontWeight: "700",
                color: "#212529",
                fontSize: "28px"
              }}
            >
              Re-Upload Court Order
            </h4>

            <div
              style={{
                fontSize: "14px",
                color: "#6c757d"
              }}
            >
              Upload updated court order document
            </div>
          </div>

          <button
            type="button"
            className="btn-close"
            onClick={() => setShowReuploadModal(false)}
          />
        </div>

        {/* BODY */}
        <div
          className="modal-body"
          style={{
            padding: "24px 26px"
          }}
        >

          {/* FILE */}
          <div className="mb-4">

            <label
              className="form-label"
              style={{
                fontWeight: "600",
                fontSize: "15px",
                marginBottom: "10px"
              }}
            >
              Upload File
            </label>

            <input
              type="file"
              className="form-control"
              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
              style={{
                height: "48px",
                borderRadius: "10px",
                padding: "10px 14px",
                fontSize: "14px"
              }}
              onChange={(e) =>
                setFiles(prev => ({
                  ...prev,
                  [reuploadAgreement]: e.target.files[0]
                }))
              }
            />

            <small
              style={{
                color: "#6c757d",
                fontSize: "12px"
              }}
            >
              Supported: JPG, PNG, PDF, DOC, DOCX
            </small>

          </div>

          {/* NOTES */}
          <div>

            <label
              className="form-label"
              style={{
                fontWeight: "600",
                fontSize: "15px",
                marginBottom: "10px"
              }}
            >
              Notes
            </label>

            <textarea
              className="form-control"
              rows="5"
              placeholder="Enter re-upload reason..."
              value={resendNotes}
              onChange={(e) =>
                setResendNotes(e.target.value)
              }
              style={{
                borderRadius: "12px",
                padding: "14px",
                resize: "none",
                fontSize: "14px"
              }}
            />

          </div>

        </div>

        {/* FOOTER */}
        <div
          className="modal-footer"
          style={{
            padding: "18px 26px",
            borderTop: "1px solid #ececec"
          }}
        >

          <button
            className="btn btn-light"
            onClick={() =>
              setShowReuploadModal(false)
            }
            style={{
              padding: "3px 10px",
              fontSize: "9px",
              minHeight: "32px",
              borderRadius: "6px",
              minWidth: "130px",
              fontWeight: "600",
              border: "1px solid #dcdcdc"
            }}
          >
            Cancel
          </button>

          <button
  className="btn btn-warning"
  onClick={submitReuploadCourtOrder}
  disabled={postLoading}
  style={{
    padding: "3px 10px",
    fontSize: "9px",
    minHeight: "32px",
    borderRadius: "6px",
    fontWeight: "600",
    textTransform: "capitalize",
    minWidth: "130px",
    opacity: postLoading ? 0.7 : 1
  }}
>
  {postLoading
    ? "Submitting..."
    : "Submit Court Order"}
</button>

        </div>

      </div>
    </div>
  </div>
)}

      {showNotesModal && (
  <div
    className="modal d-block"
    tabIndex="-1"
    style={{ background: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">
            {selectedAction === "approve"
              ? "Approve Court Order"
              : "Reject Court Order"}
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => setShowNotesModal(false)}
          />
        </div>

        <div className="modal-body">

          <label className="form-label fw-bold">
            Notes 
          </label>

          <textarea
            className="form-control"
            rows="4"
            placeholder="Enter notes..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />

        </div>

        <div className="modal-footer">

          <button
            className="btn btn-secondary"
            onClick={() => setShowNotesModal(false)}
          >
            Cancel
          </button>

          {/* --- PRELOADER: Submit button disabled while POST is in-flight --- */}
          <button
            className={`btn ${
              selectedAction === "approve"
                ? "btn-success"
                : "btn-danger"
            }`}
            onClick={submitCourtOrderAction}
            disabled={postLoading}
            style={{ opacity: postLoading ? 0.7 : 1 }}
          >
            {postLoading ? 'Submitting...' : 'Submit'}
          </button>

        </div>

      </div>
    </div>
  </div>
)}

      {/* VIEW RE-UPLOAD NOTES MODAL — Checker only */}
{showViewNotesModal && (
  <div
    className="modal show fade d-flex align-items-center justify-content-center"
    tabIndex="-1"
    style={{
      position: "fixed",
      inset: 0,
      width: "100vw",
      height: "100vh",

      background: "rgba(15, 23, 42, 0.55)",
      backdropFilter: "blur(3px)",

      zIndex: 999999,

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      padding: "20px"
    }}
  >
    <div
      className="modal-dialog"
      style={{
        width: "100%",
        maxWidth: "620px",
        margin: "0 auto",
        position: "relative",
        zIndex: 1000000
      }}
    >
      <div
        className="modal-content"
        style={{
          borderRadius: "18px",
          border: "none",
          overflow: "hidden",
          boxShadow: "0 10px 35px rgba(0,0,0,0.18)"
        }}
      >

        {/* HEADER */}
        <div
          className="modal-header"
          style={{
            padding: "22px 26px",
            borderBottom: "1px solid #ececec",
            alignItems: "center"
          }}
        >

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px"
            }}
          >

            <div
              style={{
                width: "46px",
                height: "46px",
                borderRadius: "12px",
                background: "#fff3cd",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "22px"
              }}
            >
              📝
            </div>

            <div>

              <h4
                style={{
                  margin: 0,
                  fontWeight: "700",
                  fontSize: "26px",
                  color: "#212529",
                  lineHeight: "1.2"
                }}
              >
                Re-Upload Notes
              </h4>

              <div
                style={{
                  fontSize: "14px",
                  color: "#6c757d",
                  marginTop: "3px"
                }}
              >
                Notes submitted by maker
              </div>

            </div>

          </div>

          <button
            type="button"
            className="btn-close"
            onClick={() =>
              setShowViewNotesModal(false)
            }
          />

        </div>

        {/* BODY */}
        <div
          className="modal-body"
          style={{
            padding: "24px 26px"
          }}
        >

          <div
            style={{
              background: "#f8f9fb",
              border: "1px solid #e9ecef",
              borderRadius: "14px",
              padding: "18px 20px",
              fontSize: "15px",
              color: "#343a40",
              lineHeight: "1.8",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word"
            }}
          >
            {viewNotesContent?.trim()
              ? viewNotesContent
              : "No notes provided."}
          </div>

        </div>

        {/* FOOTER */}
        <div
          className="modal-footer"
          style={{
            padding: "18px 26px",
            borderTop: "1px solid #ececec"
          }}
        >

          <button
            className="btn btn-secondary"
            onClick={() =>
              setShowViewNotesModal(false)
            }
            style={{
              minWidth: "120px",
              height: "44px",
              borderRadius: "10px",
              fontWeight: "600"
            }}
          >
            Close
          </button>

        </div>

      </div>
    </div>
  </div>
)}


{showActivityModal && (
      <div
        className="modal show fade d-flex align-items-center justify-content-center"
        tabIndex="-1"
        style={{
          background: "rgba(0,0,0,0.5)",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px"
        }}
      >
          <div
            className="modal-dialog modal-xl modal-dialog-centered"
            style={{
        maxWidth: "1350px",
        width: "92vw",
        margin: "auto"
      }}
    >
      <div className="modal-content" 
        style={{
        marginLeft: "181px"
      }}
      >

        <div className="modal-header">
          <h5 className="modal-title">
            📋 All Repo Activities
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setShowActivityModal(false);
              setActivityLogs([]);
            }}
          />
        </div>

        <div className="modal-body">

          {activityLoading ? (

            <div className="text-center py-4">
              Loading activities...
            </div>

          ) : activityLogs.length === 0 ? (

            <div className="text-center text-muted py-4">
              No activity found
            </div>

          ) : (

            <div className="table-responsive">

              <table
                  className="table table-bordered align-middle"
                  style={{
                    tableLayout: "fixed"
                  }}
                >

                <thead className="table-light">

                    <tr>

                      <th style={{ width: "60px" }}>
                        #
                      </th>

                      <th style={{ width: "55%" }}>
                        Activity
                      </th>

                      <th style={{ width: "18%" }}>
                        Created By
                      </th>

                      <th style={{ width: "22%" }}>
                        Date & Time
                      </th>

                    </tr>

                  </thead>

                <tbody>

                  {activityLogs.map((log, index) => (

                    <tr
                      key={log.id}
                      style={{
                        height: "auto"
                      }}
                    >

                      <td>{index + 1}</td>

                      <td
                        style={{
                          padding: "10px 14px",
                          lineHeight: "1.35",
                          verticalAlign: "top"
                        }}
                      >

                        <div
                        style={{
                          fontWeight: 600,
                          fontSize: "15px",
                          marginBottom: "6px",
                          color: "#212529"
                        }}
                      >
            {log.log_description}
          </div>

          {log.otherDetails && (() => {

            let details = {};

            try {

              details =
                typeof log.otherDetails === "string"
                  ? JSON.parse(log.otherDetails)
                  : log.otherDetails;

            } catch {

              details = {};

            }

            const courtOrderFile =
              details.court_order_file;

              return (

                <div className="mt-1">

                  {Object.entries(details).map(
                    ([key, value]) => {

                      if (
                        key === "court_order_file"
                      ) {

                        const fileUrl =
                          `${config.API_BASE_URL}${value}`;

                        return (

                          <div
                            key={key}
                            className="mt-1"
                          >

                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                color: "#0d6efd",
                                fontSize: "12px",
                                fontWeight: "600",
                                textDecoration: "underline"
                              }}
                            >
                              ⬇ Download Document
                            </a>

                          </div>

                        );
                      }

                     if (
                        value === null ||
                        value === "null" ||
                        value === ""
                      ) {
                        return null;
                      }
                      
                      return (
                      
                        <div
                          key={key}
                          style={{
                            fontSize: "13px",
                            color: "#6c757d",
                            marginBottom: "2px",
                            lineHeight: "1.4"
                          }}
                        >
                          <strong>
                            {key
                              .replaceAll("_", " ")
                              .toUpperCase()}
                            :
                          </strong>{" "}
                          {String(value)}
                        </div>
                      
                      );

                    }
                  )}

                </div>

              );

            })()}

          </td>

                     <td
                        style={{
                          padding: "10px",
                          fontSize: "14px",
                          verticalAlign: "middle"
                        }}
                      >
                        {log.created_by_name || "User"}
                      </td>

                      <td
                        style={{
                          padding: "10px",
                          fontSize: "14px",
                          whiteSpace: "nowrap",
                          verticalAlign: "middle"
                        }}
                    >

                        {new Date(log.created_on)
                          .toLocaleString("en-IN", {

                            day: "2-digit",
                            month: "short",
                            year: "numeric",

                            hour: "2-digit",
                            minute: "2-digit"

                          })}

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>
    </div>
  </div>
)}

{showFlowModal && selectedFlowItem && (() => {

  const allSteps = [
    "Pending",
    "Approved",
    "Pending for Court Order Review",
    "Court Order Approved",
    "Repo Initiated",
    "Repo Checklist Submitted",
    "Inspection Scheduled",
    "Inventory Created",
    "Yard Placement Pending",
    "Vehicle Yarded",
    "Ready For Listing Approval",
    "Listing Approved",
    "Live For Auction",
    "Auction Completed",
    "Sold"
  ];

  // ===== DYNAMIC STEP MAP =====
  const logStepMap = {

    "Legal action created with status Pending":
      "Pending",

    "Legal action Approved":
      "Approved",

    "Court order uploaded and sent for review":
      "Pending for Court Order Review",

    "Court Order Approved":
      "Court Order Approved",

    "Repo process initiated successfully":
      "Repo Initiated",

    "Repo checklist submitted successfully":
      "Repo Checklist Submitted",

    "Inspection scheduled successfully":
      "Inspection Scheduled",

    "Final inventory created successfully":
      "Inventory Created",

    "Yard placement updated successfully":
      "Yard Placement Pending",

    "Vehicle yarded successfully":
      "Vehicle Yarded",

    "Ready for listing approval":
      "Ready For Listing Approval",

    "Listing approved successfully":
      "Listing Approved",

    "Vehicle live for auction":
      "Live For Auction",

    "Auction completed successfully":
      "Auction Completed",

    "Vehicle sold successfully":
      "Sold"
  };

  // ===== FIND CURRENT STEP FROM ACTIVITY LOGS =====

  let currentStep = "Pending";

if (activityLogs?.length > 0) {

  const sortedLogs = [...activityLogs].sort(
    (a, b) =>
      new Date(b.created_on) -
      new Date(a.created_on)
  );

  sortedLogs.some((log) => {

    const matchedKey =
      Object.keys(logStepMap).find((key) =>
        log.log_description
          ?.toLowerCase()
          .includes(key.toLowerCase())
      );

    if (matchedKey) {

      currentStep = logStepMap[matchedKey];

      return true;

    }

    return false;

  });

}

  const currentIndex =
    allSteps.indexOf(currentStep);
    const activeIndex = currentIndex + 1;

  return (

    <div
      className="modal show fade d-flex align-items-center justify-content-center"
      style={{
        background: "rgba(0,0,0,0.45)",
        position: "fixed",
        inset: 0,
        zIndex: 999999
      }}
    >

      <div
        className="modal-dialog modal-dialog-centered"
        style={{
          maxWidth: "680px",
          width: "95%"
        }}
      >

        <div
          className="modal-content"
          style={{
            borderRadius: "22px",
            overflow: "hidden",
            border: "none",
            boxShadow: "0 20px 60px rgba(0,0,0,0.18)"
          }}
        >

          {/* HEADER */}

          <div
            className="modal-header"
            style={{
              background:
                "linear-gradient(135deg,#0f172a,#1e293b)",
              color: "#fff",
              padding: "20px 28px",
              border: "none"
            }}
          >

            <div>

              <h4
                style={{
                  margin: 0,
                  fontWeight: "700"
                }}
              >
                Repo Progress Flow
              </h4>

              <div
                style={{
                  opacity: 0.8,
                  fontSize: "13px",
                  marginTop: "4px"
                }}
              >
                Agreement No :
                {" "}
                {selectedFlowItem.AgreementNo}
              </div>

            </div>

            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() =>
                setShowFlowModal(false)
              }
            />

          </div>

          {/* BODY */}

          <div
            className="modal-body"
            style={{
              padding: "30px 26px",
              background: "#f8fafc",
              maxHeight: "70vh",
              overflowY: "auto"
            }}
          >

            {allSteps.map((step, index) => {

              const completed =
                index <= currentIndex;

              const active =
                index === activeIndex;

              return (

                <div
                  key={step}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "28px",
                    position: "relative"
                  }}
                >

                  {/* LINE */}

                  {index !== allSteps.length - 1 && (
                    <div
                      style={{
                        position: "absolute",
                        left: "20px",
                        top: "42px",
                        width: "4px",
                        height: "60px",
                        background:
                          completed
                            ? "#16a34a"
                            : "#d4d4d8",
                        borderRadius: "20px"
                      }}
                    />
                  )}

                  {/* CIRCLE */}

                  <div
                    style={{
                      minWidth: "42px",
                      height: "42px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "700",
                      color: "#fff",
                      fontSize: "15px",
                      zIndex: 2,
                      background:
                        completed
                          ? "#16a34a"
                          : active
                          ? "#f59e0b"
                          : "#cbd5e1",
                      animation:
                        active
                          ? "pulse 1.2s infinite"
                          : "none",
                      boxShadow:
                        completed
                          ? "0 0 15px rgba(22,163,74,0.35)"
                          : active
                          ? "0 0 18px rgba(245,158,11,0.45)"
                          : "none"
                    }}
                  >
                    {completed ? "✓" : index + 1}
                  </div>

                  {/* CONTENT */}

                  <div
                    style={{
                      marginLeft: "18px",
                      flex: 1
                    }}
                  >

                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color:
                          completed || active
                            ? "#0f172a"
                            : "#64748b"
                      }}
                    >
                      {step}
                    </div>

                    <div
                      style={{
                        fontSize: "13px",
                        marginTop: "3px",
                        color: "#64748b"
                      }}
                    >

                      {completed
                        ? "Completed Successfully"
                        : active
                        ? "Current Active Step"
                        : "Waiting"}

                    </div>

                  </div>

                </div>

              );

            })}

          </div>

        </div>

      </div>

      <style>
        {`
          @keyframes pulse {

            0% {
              transform: scale(1);
              opacity: 1;
            }

            50% {
              transform: scale(1.08);
              opacity: 0.7;
            }

            100% {
              transform: scale(1);
              opacity: 1;
            }

          }
        `}
      </style>

    </div>

  );

})()}
    </Container>
    
  );
}

export default VehicleRepoList;